import { Collapse, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { FC } from 'react';
import { useLesson } from '../../LessonProvider';
import CstaStandardList from './CstaStandardList';
import SubjectBasedLists from './SubjectBasedLists';
import SubmitterName from './SubmitterName';

interface Props {
  expanded: boolean;
}

const useStyles = makeStyles({
  detailsContainer: {
    margin: 24,
  },
  detailsSection: {
    marginBottom: 16,
  },
});

const Details: FC<Props> = ({ expanded }) => {
  const {
    contentStrands,
    cstaStandards,
    displayPublicly,
    educatorName,
    mnStandards,
    twitterId,
    emailAddress,
  } = useLesson();

  const styles = useStyles();

  return (
    <Collapse in={expanded} timeout="auto" unmountOnExit>
      <div className={styles.detailsContainer}>
        <div className={styles.detailsSection}>
          <SubjectBasedLists title="Content Strands" subjectLists={contentStrands || {}} />
        </div>
        <div className={styles.detailsSection}>
          <CstaStandardList title="CSTA Standards" listItems={cstaStandards || []} />
        </div>
        <div className={styles.detailsSection}>
          <SubjectBasedLists
            title="Academic Standards"
            subjectLists={mnStandards || {}}
            showMnStandardsLink
          />
        </div>
        <Typography variant="body2">
          Submitted by{' '}
          <SubmitterName
            displayPublicly={displayPublicly}
            twitterId={twitterId}
            emailAddress={emailAddress}
          >
            {educatorName}
          </SubmitterName>
        </Typography>
      </div>
    </Collapse>
  );
};

export default Details;
